import { Check, Copy } from 'lucide-react';
import { clsx } from 'clsx';
import { useCopyToClipboard } from '@/hooks/useCopyToClipboard';

type Props = {
  value: string;
  label?: string;
  copiedLabel?: string;
  className?: string;
};

/**
 * Bouton de copie neobrutal pour les blocs de commande terminal.
 * Consomme `useCopyToClipboard`. Annonce l'état via aria-live.
 */
export function CopyButton({
  value,
  label = 'Copier',
  copiedLabel = 'Copié',
  className,
}: Props) {
  const { copied, copy } = useCopyToClipboard();

  return (
    <button
      type="button"
      onClick={() => void copy(value)}
      aria-label={copied ? copiedLabel : `${label} la commande`}
      className={clsx(
        'inline-flex shrink-0 items-center gap-1.5 border-2 border-charcoal-800 px-3 py-1.5 font-marketing-mono text-[11px] font-semibold uppercase tracking-[0.08em] shadow-neobrutal-2 transition-all duration-150 cursor-pointer hover:-translate-x-[1px] hover:-translate-y-[1px] hover:shadow-neobrutal-4 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lime-400 focus-visible:ring-offset-2 focus-visible:ring-offset-charcoal-800',
        copied ? 'bg-lime-500 text-charcoal-800' : 'bg-white text-charcoal-800',
        className,
      )}
    >
      {copied ? (
        <Check className="h-3.5 w-3.5" strokeWidth={2.8} aria-hidden="true" />
      ) : (
        <Copy className="h-3.5 w-3.5" strokeWidth={2.4} aria-hidden="true" />
      )}
      <span aria-live="polite">{copied ? copiedLabel : label}</span>
    </button>
  );
}
